export const GET_STUDENT_LIST_REQUEST = 'GET_STUDENT_LIST_REQUEST'
export const GET_STUDENT_LIST_FAIL = 'GET_STUDENT_LIST_FAIL'
export const GET_STUDENT_LIST_SUCCESS = 'GET_STUDENT_LIST_SUCCESS'

export const UPDATE_STUDENT_ROOM_STATUS_FILTER = 'UPDATE_STUDENT_ROOM_STATUS_FILTER'
export const UPDATE_STUDENT_ROOM_FILTER = 'UPDATE_STUDENT_ROOM_FILTER'
export const UPDATE_STUDENT_COURSE_FILTER = 'UPDATE_STUDENT_COURSE_FILTER'

export const STUDENT_LIST_SET_PAGINATION = 'STUDENT_LIST_SET_PAGINATION'
